<kendo-dialog title="{{ constantHelper.LBL_COMMON_WARNING | translate}}" *ngIf="isConfirmOpen" (close)="close()" [minWidth]="250" [width]="450">
  <p class="message">{{ message }}</p>
  <div class="dialog-actions">
    <button class="btn btn-primary" (click)="close(true)">{{ constantHelper.LBL_COMMON_YES | translate}}</button>
    <button class="btn btn-outline-secondary mr-2" (click)="close()">{{ constantHelper.LBL_COMMON_NO | translate}}</button>
  </div>
</kendo-dialog>

